import { BillingReportRow } from '../types';

export enum BillingItemFlagType {
  IGNORE_ERROR = 'ignore_error',
  MANUALLY_HELD = 'manually_held'
}

export interface BulkBillingItemFlag {
  rows: BillingReportRow[];
  alerts?: Record<string, string[]>;
  type: BillingItemFlagType;
  reason: string;
  note: string | null;
}

export interface BulkIgnoreErrorsFlag extends BulkBillingItemFlag {
  alerts: Record<string, string[]>;
}

export interface BulkBillingItemFlagPayload {
  billingItemIds: string[];
  type: BillingItemFlagType;
  alerts?: Record<string, string[]>;
  reason: string;
  note: string | null;
}
export interface ClearIgnoreErrorsPayload {
  type: string;
  billingItemIds: string[];
  onlyForUser: boolean;
}
